<template>
  <div id="Add_office" class="xv_modal">
    <div class="modal_title">
      <div>
        <span>New Office</span>
      </div>
      <div>
        <button class="modal_close" @click="close_add_office()">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
    </div>
    <div class="modal_content">
      <div class="row">
        <div class="col-12">
          <label>Name</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Address</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <input type="text" placeholder="State" />
        </div>
        <div class="col-6">
          <input type="text" placeholder="City" />
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <input type="text" placeholder="Pin" />
        </div>
        <div class="col-6">
          <input type="text" placeholder="Country" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>GPS location</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Contact Number</label>
          <input type="text" placeholder />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label>Admin</label>
          <select name id>
            <option value="1">Jasmine Morgan</option>
            <option value="1">Joseph Davis</option>
            <option value="1">Haleema Andrews</option>
            <option value="1">Yasmine Hoffman</option>
            <option value="1">Anthony Cook</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label>Status</label>
          <select name id>
            <option value="1">Ok</option>
            <option value="1">Closed</option>
          </select>
        </div>
        <div class="col-4">
          <label>Till when</label>
          <input type="text" />
        </div>
        <div class="col-4">
          <label>Comments</label>
          <input type="text" />
        </div>
      </div>
    </div>
    <div class="modal_footer">
      <button class="sec_btn m_r" @click="close_add_office()">Cancel</button>
      <button class="main_btn">Add</button>
    </div>
  </div>
</template>

<script>
// import employeePolicies from "./employee_policies/employee_policies.vue"

export default {
  name: "Add_office",
  components: {
    // employeePolicies,visitorPolicies,healthDeclarations,securityPartners,company,account
  },
  data() {
    return {
      step_count: 1
    };
  },
  methods: {
    close_add_office: function() {
      this.$modal.hide("add_office");
    }
  }
};
</script>
